import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment'
import ResidenceCancelModal from './ResidenceCancelModal';

import { BookingInfo, ButtonVerticalCenter, LogeButtonSlim } from './ActiveResidenceBookingsStyle'

@inject('residenceBookingStore')

@observer
class ActiveResidenceBookingsRow extends Component {

  constructor(props) {
    super(props)
    this.openCancelModal = this.openCancelModal.bind(this)
  }


  openCancelModal() {
    this.cancelmodal.openModal();
  }

  render() {
    const { booking } = this.props

    return (
      <div style={{ paddingBottom: 25 }}>
        <Row>
          <Col xs={12} sm={7} md={10} lg={10}>
            <div>
              <BookingInfo style={{fontWeight: "bold"}}>{moment(booking.arrival.iso).subtract(2, 'hours').locale("de").format('Do MMMM YYYY')} - {moment(booking.depature.iso).subtract(2, 'hours').locale("de").format('Do MMMM YYYY')}</BookingInfo>
            </div>
            {!this.props.isPast ?
              <div>
                <BookingInfo>{'geplante Ankunftszeit'} {booking.arrivalTime} Uhr</BookingInfo>
                <BookingInfo>Abreise bis 10 Uhr</BookingInfo>
              </div>
              : ''}

            {booking.isRemainingStock === true &&
              <div >
                <BookingInfo><span style={{fontWeight: 400}}>Restplatzbuchung</span></BookingInfo>
              </div>}
          </Col>
          {!this.props.isPast ?
            <Col xs={12} sm={5} md={2} lg={2}>
              <ButtonVerticalCenter>
                <LogeButtonSlim
                  hoverFontColor={"white"}
                  onClick={this.openCancelModal}
                  style={{ float: "right", margin: 0, borderRadius: 0, textTransform: 'uppercase' }}>
                  Stornieren</LogeButtonSlim>
              </ButtonVerticalCenter>
            </Col>
            : ''
          }
        </Row>

        <ResidenceCancelModal
          onRef={ref => (this.cancelmodal = ref)}
          bookingId={booking.objectId}
          residenceName={"Marbella"}
          arrival={booking.arrival.iso}
          depature={booking.depature.iso}
        />
      </div>
    )
  }
}

ActiveResidenceBookingsRow.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject
};

export default ActiveResidenceBookingsRow;



// WEBPACK FOOTER //
// /src/components/internal/Residence/ActiveResidenceBookingsRow.js